var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVostokLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M76.6693 16.8979L88.4184 8.31771C78.8513 3.60703 40.7507 -4.46843 15.4062 30.1888C28.4981 15.2155 48.1359 10.6731 76.6693 16.8979Z",
    fill: "url(#paint0_linear_1628_13116)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2542 104.102L29.5051 112.682C39.0723 117.393 77.1729 125.468 102.517 90.8112C89.4255 105.785 69.7877 110.327 41.2542 104.102Z",
    fill: "url(#paint1_linear_1628_13116)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5194 19.2434C25.3092 21.7723 15.2386 27.9919 10.0354 40.6098C19.2668 25.8048 32.5265 21.4306 45.6184 21.2623C60.3886 20.5893 74.991 29.506 82.0405 40.6098C82.0405 40.6098 108.612 40.4415 108.728 40.6098C101.51 30.0107 88.9221 21.5988 76.6695 18.0658C58.3745 13.1869 42.2614 14.8692 31.5194 19.2434Z",
    fill: "url(#paint2_linear_1628_13116)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2365 101.747C92.4467 99.218 102.517 92.9984 107.72 80.3804C98.489 95.1855 85.2293 99.5596 72.1374 99.7279C57.3672 100.401 42.7648 91.4842 35.7154 80.3804C35.7154 80.3804 9.14337 80.5487 9.02821 80.3804C16.2455 90.9795 28.8338 99.3915 41.0864 102.924C59.3814 107.803 75.4944 106.121 86.2365 101.747Z",
    fill: "url(#paint3_linear_1628_13116)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M96.475 76.8474L106.21 76.8474C104.532 82.7358 95.8036 97.5408 76.5016 94.3443C92.4467 94.849 96.475 81.8946 96.475 76.8474Z",
    fill: "url(#paint4_linear_1628_13116)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4488 44.1506L11.7139 44.1506C13.3923 38.2622 22.1202 23.4572 41.4223 26.6537C25.4771 26.149 21.4488 39.1034 21.4488 44.1506Z",
    fill: "url(#paint5_linear_1628_13116)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M5 53.8218C5 53.5292 5.10479 53.2779 5.31438 53.0678C5.52397 52.8577 5.77472 52.7527 6.06665 52.7527H15.1949C16.2204 52.7527 17.1523 52.8952 17.9906 53.1803C18.8365 53.4654 19.555 53.9681 20.1464 54.6884C20.7377 55.4012 21.0334 56.2865 21.0334 57.3444C21.0334 58.4998 20.5281 59.4902 19.5176 60.3155C20.9623 61.0808 21.6808 62.3263 21.6734 64.0519C21.6734 65.59 21.097 66.783 19.9443 67.6308C18.799 68.4711 17.3918 68.8913 15.7226 68.8913H6.06665C5.77472 68.8913 5.52397 68.79 5.31438 68.5874C5.10479 68.3773 5 68.126 5 67.8334V53.8218ZM9.2329 65.8526H15.6552C16.2391 65.8526 16.6807 65.6801 16.9801 65.3349C17.287 64.9898 17.4405 64.5171 17.4405 63.9169C17.4405 63.3167 17.287 62.844 16.9801 62.4989C16.6732 62.1537 16.2316 61.9812 15.6552 61.9812H9.2329V65.8526ZM9.2329 59.0213H15.2398C15.7114 59.0213 16.0894 58.8825 16.3738 58.6049C16.6583 58.3198 16.8005 57.9259 16.8005 57.4232C16.8005 56.913 16.6583 56.5153 16.3738 56.2302C16.0894 55.9451 15.7114 55.8026 15.2398 55.8026H9.2329V59.0213Z",
    fill: "url(#paint6_linear_1628_13116)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3561 67.2256C23.8216 65.8751 23.0544 63.7406 23.0544 60.822C23.0544 57.9034 23.8216 55.7726 25.3561 54.4296C26.8906 53.0865 29.1361 52.415 32.0928 52.415C35.057 52.415 37.3025 53.0865 38.8295 54.4296C40.364 55.7726 41.1312 57.9034 41.1312 60.822C41.1312 63.7406 40.364 65.8751 38.8295 67.2256C37.3025 68.5686 35.057 69.2402 32.0928 69.2402C29.1361 69.2402 26.8906 68.5686 25.3561 67.2256ZM28.4213 56.8042C27.6653 57.7045 27.2873 59.0475 27.2873 60.8332C27.2873 62.6114 27.6653 63.9507 28.4213 64.851C29.1848 65.7438 30.4086 66.1902 32.0928 66.1902C33.7845 66.1902 35.0083 65.7438 35.7643 64.851C36.5203 63.9507 36.8983 62.6114 36.8983 60.8332C36.8983 59.0475 36.5203 57.7045 35.7643 56.8042C35.0083 55.9039 33.7845 55.4537 32.0928 55.4537C30.4086 55.4537 29.1848 55.9039 28.4213 56.8042Z",
    fill: "url(#paint7_linear_1628_13116)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5782 66.9893C43.1934 65.6613 42.501 63.6093 42.501 60.8332C42.501 58.0497 43.1934 55.9939 44.5782 54.6659C45.9704 53.3304 48.0551 52.6626 50.8321 52.6626H53.3359C55.0351 52.6626 56.5358 53.1053 57.8383 53.9906C59.1482 54.876 59.8032 56.0877 59.8032 57.6258C59.8032 58.0684 59.6722 58.3873 59.4102 58.5824C59.1482 58.7699 58.8937 58.8637 58.6467 58.8637H57.3106C56.6219 58.8637 56.0867 58.4511 55.705 57.6258C55.1511 56.4403 54.2304 55.8476 52.9429 55.8476H50.9444C49.3051 55.8476 48.1936 56.2002 47.6097 56.9055C47.0259 57.6108 46.7339 58.9162 46.7339 60.822C46.7339 62.7277 47.0259 64.0369 47.6097 64.7497C48.1936 65.455 49.3051 65.8076 50.9444 65.8076H53.1787C54.4662 65.8076 55.3831 65.2149 55.9295 64.0294C56.3113 63.1966 56.8502 62.7802 57.5464 62.7802H58.8825C59.0172 62.7802 59.1594 62.8102 59.3091 62.8702C59.4663 62.9228 59.6235 63.0541 59.7807 63.2641C59.9454 63.4667 60.0277 63.7218 60.0277 64.0294C60.0277 65.5675 59.3765 66.7792 58.0741 67.6646C56.7716 68.5424 55.2708 68.9813 53.5717 68.9813H50.8321C48.0551 68.9813 45.9704 68.3173 44.5782 66.9893Z",
    fill: "url(#paint8_linear_1628_13116)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M60.3645 54.8797V53.8218C60.3645 53.5142 60.4656 53.2591 60.6677 53.0565C60.8698 52.854 61.1243 52.7527 61.4312 52.7527H75.6793C75.9862 52.7527 76.2407 52.854 76.4428 53.0565C76.6449 53.2591 76.746 53.5142 76.746 53.8218V54.8797C76.746 55.1873 76.6449 55.4424 76.4428 55.645C76.2407 55.8401 75.9862 55.9376 75.6793 55.9376H70.6717V67.8559C70.6717 68.1485 70.5669 68.3961 70.3573 68.5987C70.1552 68.7937 69.9082 68.8913 69.6163 68.8913H67.4942C67.2023 68.8913 66.9516 68.7937 66.742 68.5987C66.5399 68.3961 66.4388 68.1485 66.4388 67.8559V55.9376H61.4312C61.1243 55.9376 60.8698 55.8401 60.6677 55.645C60.4656 55.4424 60.3645 55.1873 60.3645 54.8797Z",
    fill: "url(#paint9_linear_1628_13116)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M79.2722 67.2256C77.7378 65.8751 76.9705 63.7406 76.9705 60.822C76.9705 57.9034 77.7378 55.7726 79.2722 54.4296C80.8067 53.0865 83.0523 52.415 86.009 52.415C88.9731 52.415 91.2187 53.0865 92.7457 54.4296C94.2802 55.7726 95.0474 57.9034 95.0474 60.822C95.0474 63.7406 94.2802 65.8751 92.7457 67.2256C91.2187 68.5686 88.9731 69.2402 86.009 69.2402C83.0523 69.2402 80.8067 68.5686 79.2722 67.2256ZM82.3375 56.8042C81.5814 57.7045 81.2034 59.0475 81.2034 60.8332C81.2034 62.6114 81.5814 63.9507 82.3375 64.851C83.101 65.7438 84.3248 66.1902 86.009 66.1902C87.7006 66.1902 88.9245 65.7438 89.6805 64.851C90.4365 63.9507 90.8145 62.6114 90.8145 60.8332C90.8145 59.0475 90.4365 57.7045 89.6805 56.8042C88.9245 55.9039 87.7006 55.4537 86.009 55.4537C84.3248 55.4537 83.101 55.9039 82.3375 56.8042Z",
    fill: "url(#paint10_linear_1628_13116)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3379 67.8109V53.8218C97.3379 53.5292 97.4427 53.2741 97.6522 53.0565C97.8618 52.8389 98.1126 52.7302 98.4045 52.7302H100.515C100.807 52.7302 101.054 52.8389 101.256 53.0565C101.466 53.2741 101.571 53.5292 101.571 53.8218V59.2126H103.985C104.643 59.2126 105.22 59.0325 105.714 58.6724C106.215 58.3123 106.691 57.7308 107.14 56.928L108.88 53.8218C109.277 53.1015 109.816 52.7377 110.497 52.7302H113.091C113.382 52.7302 113.555 52.8352 113.607 53.0453C113.622 53.0978 113.629 53.1503 113.629 53.2028C113.629 53.3754 113.566 53.5817 113.439 53.8218L111.002 58.2447C110.65 58.89 110.254 59.4227 109.812 59.8428C109.378 60.263 108.809 60.5594 108.105 60.7319C108.599 60.837 109.105 61.1483 109.621 61.666C110.145 62.1837 110.605 62.7464 111.002 63.3542L113.809 67.8334C113.936 68.051 114 68.2385 114 68.3961C114 68.4636 113.989 68.5274 113.966 68.5874C113.891 68.79 113.708 68.8913 113.416 68.8913H110.845C110.553 68.8913 110.239 68.79 109.902 68.5874C109.565 68.3773 109.303 68.126 109.116 67.8334L107.14 64.6934C106.668 63.9281 106.193 63.3542 105.714 62.9715C105.235 62.5814 104.658 62.3863 103.985 62.3863H101.571V67.8559C101.571 68.1485 101.466 68.3961 101.256 68.5987C101.054 68.7937 100.807 68.8913 100.515 68.8913H98.4045C98.1126 68.8913 97.8618 68.7862 97.6522 68.5761C97.4427 68.3586 97.3379 68.1035 97.3379 67.8109Z",
    fill: "url(#paint11_linear_1628_13116)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1628_13116",
    x1: 15.4063,
    y1: 30.2453,
    x2: 88.2775,
    y2: 8.9712,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2674B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7BD0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1628_13116",
    x1: 102.517,
    y1: 90.7548,
    x2: 29.6461,
    y2: 112.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2675B0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7AD0F2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1628_13116",
    x1: 108.728,
    y1: 40.6758,
    x2: 11.6535,
    y2: 2.80851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1628_13116",
    x1: 9.02812,
    y1: 80.3144,
    x2: 106.102,
    y2: 118.182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1628_13116",
    x1: 78.5157,
    y1: 94.4886,
    x2: 102.221,
    y2: 77.045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1628_13116",
    x1: 39.4081,
    y1: 26.5094,
    x2: 15.703,
    y2: 43.953,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFDC00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E64011"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1628_13116",
    x1: 58.783,
    y1: 52.9086,
    x2: 58.783,
    y2: 68.8913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FBEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2690CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_1628_13116",
    x1: 58.783,
    y1: 52.9086,
    x2: 58.783,
    y2: 68.8913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FBEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2690CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_1628_13116",
    x1: 58.783,
    y1: 52.9086,
    x2: 58.783,
    y2: 68.8913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FBEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2690CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_1628_13116",
    x1: 58.783,
    y1: 52.9086,
    x2: 58.783,
    y2: 68.8913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FBEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2690CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_1628_13116",
    x1: 58.783,
    y1: 52.9086,
    x2: 58.783,
    y2: 68.8913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FBEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2690CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_1628_13116",
    x1: 58.783,
    y1: 52.9086,
    x2: 58.783,
    y2: 68.8913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5FBEE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2690CB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVostokLogo);
export default __webpack_public_path__ + "static/media/vostokLogo.82e22c54f07b26f0aff076af0869e8f9.svg";
export { ForwardRef as ReactComponent };